import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './shared/login/login.component';
import {ResetComponent} from './shared/reset/reset.component';
import {EnterpriseDatasetUploadComponent} from './enterprise/dataset-upload/dataset-upload.component';
import {EnterpriseDatasetConfigurationComponent} from './enterprise/dataset-configuration/dataset-configuration.component';
import {EnterpriseGenerateInsightsComponent} from './enterprise/generate-insights/generate-insights.component';
import {EnterpriseInsightDetailsComponent} from './enterprise/insight-details/insight-details.component';
import {EnterpriseDatasetsComponent} from './enterprise/enterprise-datasets/enterprise-datasets.component';
import {EnterpriseMlModelsComponent} from './enterprise/enterprise-mlmodels/enterprise-mlmodels.component';
import {EnterpriseInsightsComponent} from './enterprise/enterprise-insights/enterprise-insights.component';
import {SharedDatasetsComponent} from './shared/datasets/datasets.component';
import {PredictionsListComponent} from './vendor/predictions/list/predictions-list.component';
import {PredictionsUploadComponent} from './vendor/predictions/upload/predictions-upload.component';
import {AuthGuard} from './auth/auth.guard';
import {HomeResolveService} from './services/home-resolve.service';
import { SupportComponent } from './shared/support/support.component';
import { ProfileComponent } from './shared/profile/profile.component';
import {TestModelComponent} from './enterprise/test-model/test-model.component';
import {SignupComponent} from './shared/signup/signup.component';
import {PasswordResetComponent} from './shared/password-reset/password-reset.component';
import {PasswordConfirmationComponent} from './shared/password-confirmation/password-confirmation.component';
import {PrivacyComponent} from './shared/privacy/privacy.component';
import {PrivacyOrganisationComponent} from './shared/privacy-organisation/privacy-organisation.component';
import {TermsComponent} from './shared/terms/terms.component';
import {TermsOrganisationComponent} from './shared/terms-organisation/terms-organisation.component';
import {TransparencyComponent} from './shared/transparency/transparency.component';
import {ThirdPartyComponent} from './shared/third-party/third-party.component';
import {PortalComponent} from './leaderboard/portal/portal.component';
import {ForumsComponent} from './leaderboard/forum/forums/forums.component';
import {MessagesComponent} from './leaderboard/forum/messages/messages.component';
import {NewForumComponent} from './leaderboard/forum/new-forum/new-forum.component';
import {LeaderboardV2Component} from './leaderboard/leaderboard-v2/leaderboard-v2.component';
import {EnterpriseFreeTrialExpiredComponent} from './enterprise/free-trial-expired/free-trial-expired.component';
import {EnterpriseUsersComponent} from './enterprise/management/users/enterprise-users.component';
import {RulesComponent} from './leaderboard/rules/rules.component';
import {PrizeComponent} from './leaderboard/prize/prize.component';
import {TeamsComponent} from './vendor/teams/teams.component';
import {IframIAComponent} from './shared/ia-iframe/ia-iframe.component';
import { AskAiComponent } from './leaderboard/ask-ai/ask-ai.component';

const routes: Routes = [
  {
    path: '', component: LoginComponent, resolve: {
      data: HomeResolveService
    }
  },
  {path: 'login', component: LoginComponent},
  {path: 'password/change', component: ResetComponent},
  {path: 'enterprise/datasets/upload', component: EnterpriseDatasetUploadComponent, canActivate: [AuthGuard]},
  {path: 'enterprise/datasets/:datasetId/configuration', component: EnterpriseDatasetConfigurationComponent, canActivate: [AuthGuard]},
  {path: 'enterprise/mlmodels/:mlmodelid/insights/generate', component: EnterpriseGenerateInsightsComponent, canActivate: [AuthGuard]},
  {path: 'enterprise/insights/:insightId', component: EnterpriseInsightDetailsComponent, canActivate: [AuthGuard]},
  {path: 'enterprise/datasets', component: EnterpriseDatasetsComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always'},
  {path: 'datasets', component: SharedDatasetsComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always'},
  {path: 'enterprise/free-trial-expired', component: EnterpriseFreeTrialExpiredComponent, canActivate: [AuthGuard]},
  {path: 'datasets/:datasetId/forums', component: ForumsComponent, canActivate: [AuthGuard]},
  {path: 'datasets/:datasetId/forums/:forumId/messages', component: MessagesComponent, canActivate: [AuthGuard]},
  {path: 'datasets/:datasetId/forums/new', component: NewForumComponent, canActivate: [AuthGuard]},
  {path: 'datasets/:datasetId/ask-ai', component: AskAiComponent, canActivate: [AuthGuard]},
  {path: 'enterprise/mlmodels', component: EnterpriseMlModelsComponent, canActivate: [AuthGuard]},
  {
    path: 'enterprise/datasets/:datasetId/mlmodels',
    component: EnterpriseMlModelsComponent,
    canActivate: [AuthGuard]
  },
  {path: 'enterprise/insights', component: EnterpriseInsightsComponent, canActivate: [AuthGuard]},
  {
    path: 'enterprise/datasets/:datasetId/insights',
    component: EnterpriseInsightsComponent,
    canActivate: [AuthGuard]
  },
  {path: 'enterprise/test', component: TestModelComponent, canActivate: [AuthGuard]},
  {path: 'enterprise/users', component: EnterpriseUsersComponent, canActivate: [AuthGuard]},
  {path: 'iframe', component: IframIAComponent, canActivate: [AuthGuard]},
  {path: 'datasets/:datasetId', component: PortalComponent, canActivate: [AuthGuard]},
  {
    path: 'vendor/datasets/:datasetId/predictions',
    component: PredictionsListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'vendor/datasets/:datasetId/predictions/upload',
    component: PredictionsUploadComponent,
    canActivate: [AuthGuard]
  },
  {path: 'datasets/:datasetId/rules', component: RulesComponent, canActivate: [AuthGuard]},
  {path: 'datasets/:datasetId/prize', component: PrizeComponent, canActivate: [AuthGuard]},
  {path: 'datasets/:datasetId/team', component: TeamsComponent, canActivate: [AuthGuard]},
  {path: 'leaderboard-v2/:datasetId', component: LeaderboardV2Component, canActivate: [AuthGuard]},
  {path: 'support', component: SupportComponent, canActivate: [AuthGuard]},
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
  {path: 'signup', component: SignupComponent},
  {path: 'password/reset', component: PasswordResetComponent},
  {path: 'password/confirmation', component: PasswordConfirmationComponent},
  {path: 'privacy', component: PrivacyComponent},
  {path: 'privacy-organisation', component: PrivacyOrganisationComponent},
  {path: 'transparency', component: TransparencyComponent},
  {path: 'thirdparty', component: ThirdPartyComponent},
  // {path: 'terms', component: TermsComponent}, -- @todo remove component etc
  {path: 'terms-organisation', component: TermsOrganisationComponent},
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
